import { GetClientsForDetailsQueryVariables } from "../../generated/graphql";

export type GlobalClientSearchCriteria = GetClientsForDetailsQueryVariables;
export const clientCardType = "ClientCard" as const;
